import { render } from "./StockAlert.vue?vue&type=template&id=42dceb04&ts=true"
import script from "./StockAlert.vue?vue&type=script&lang=ts"
export * from "./StockAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__